import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { MergePurgeParameters } from './types/merge-purge-parameters.type';
import type { TwentileCount } from './types/twentile-count.type';

/**
 * Retrieves the twentile count data for a merge-purge report.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param searchParams - The parameters for the merge-purge operation.
 * @returns A promise that resolves to an {@link OperationResultWithData} containing an array
 * of {@link TwentileCount}.
 * @throws Will throw an error if the request fails.
 */
export const getTwentileCount = async (instance: KyInstance, searchParams: MergePurgeParameters) => {
  try {
    return await instance
      .get<OperationResultWithData<TwentileCount[]>>(Uri.reports.mergePurge.twentileCount, {
        searchParams,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
